class VariantPickerPort extends HTMLElement {
  #formId = null;

  constructor() {
    super();
    this.#formId = this.dataset.productFormId;
    this.selectedPort = null;
    this.selectedVariant = null;
    this.modalImages = null;
    this.mediaSlideImages = null;
    this.mediaSlideSrc = null;
    this.mediaSlideSrcset = null;
    this.mediaSlideSizes = null;
    this.modalImageSrc = null;
    this.modalImageSrcset = null;
    this.modalImageSizes = null;
    this.initAutocomplete();
  }

  initSelectedMeta(isOverwrite = false) {
    this.spinner = document.querySelector(".loading__spinner");
    this.modalImages = document.querySelectorAll(
      ".product-media-modal__content img"
    );
    this.mediaSlideImages = document.querySelectorAll(
      ".product__media-list li img"
    );
    this.mediaSlideSrc = `${this.mediaSlideImages[0].src}`;
    this.mediaSlideSrcset = `${this.mediaSlideImages[0].srcset}`;
    this.mediaSlideSizes = `${this.mediaSlideImages[0].sizes}`;
    this.modalImageSrc = `${this.modalImages[0].src}`;
    this.modalImageSrcset = `${this.modalImages[0].srcset}`;
    this.modalImageSizes = `${this.modalImages[0].sizes}`;
  }

  resetSelectedMeta() {
    this.mediaSlideImages[0].src = this.mediaSlideSrc;
    this.mediaSlideImages[0].srcset = this.mediaSlideSrcset;
    this.mediaSlideImages[0].sizes = this.mediaSlideSizes;
    this.modalImages[0].src = this.modalImageSrc;
    this.modalImages[0].srcset = this.modalImageSrcset;
    this.modalImages[0].sizes = this.modalImageSizes;
  }

  getCurrentVariantPathSlug() {
    const selectedVariantEl = document.querySelector("#selected-variant");
    const selectedVariant = selectedVariantEl
      ? JSON.parse(selectedVariantEl.innerHTML)
      : null;
    return selectedVariant?.id
      ? PORT_STICKER_VARIANTS[selectedVariant.id].pathSlug
      : null;
  }

  initAutocomplete() {
    const self = this;
    const { liteClient: algoliasearch } = window["algoliasearch/lite"];
    const { autocomplete, getAlgoliaResults } =
      window["@algolia/autocomplete-js"];

    const searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY);

    this.initSelectedMeta();

    const isMobile = window.matchMedia("(max-width: 749px)").matches;

    autocomplete({
      container: "#autocomplete",
      ...(isMobile ? {} : { panelContainer: document.querySelector("#autocomplete") }),
      insights: true,
      placeholder: "Type to search for a port",
      onReset() {
        self.spinner.classList.remove("hidden");
        self.selectedPort = null;
        self.printFileInput.value = null;
        self.summaryInput.value = null;
        self.resetSelectedMeta();
        self.updateAddToCartButton();
        setTimeout(() => {
          self.spinner.classList.add("hidden");
        }, 1300);
      },
      getSources() {
        return [
          {
            sourceId: "ports",
            getItems({ query }) {
              return getAlgoliaResults({
                searchClient,
                queries: [
                  {
                    query,
                    indexName: "ports",
                    filters: "has_badge:true",
                  },
                ],
              });
            },
            getItemInputValue({ item }) {
              return item.name;
            },
            templates: {
              item({ item, html }) {
                return html`
                  <div style="padding: 6px 0;">
                    <strong>${item.name}</strong>
                  </div>
                `;
              },
            },
            onSelect(params) {
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
              self.spinner.classList.remove("hidden");
              const { item } = params;
              self.selectedPort = item;
              const pathSlug = self.getCurrentVariantPathSlug();
              const displayImageUrl = `${SB_IMG_BASE}/cruise-badges/ports/${pathSlug}/${item.slug}.jpg`;
              const designImageUrl = `${SB_IMG_BASE}/cruise-badges/ports/design/${pathSlug}/${item.slug}.png`;
              self.printFileInput.value = designImageUrl;
              self.summaryInput.value = `${item.name} ${pathSlug} Sticker`;
              self.mediaSlideImages[0].src = displayImageUrl;
              self.mediaSlideImages[0].removeAttribute("srcset");
              self.mediaSlideImages[0].removeAttribute("sizes");
              self.modalImages[0].src = displayImageUrl;
              self.modalImages[0].removeAttribute("srcset");
              self.modalImages[0].removeAttribute("sizes");
              self.updateAddToCartButton();
              setTimeout(() => {
                self.spinner.classList.add("hidden");
              }, 1300);
            },
          },
        ];
      },
    });
  }

  connectedCallback() {
    this.waitForForm().then(() => {
      this.printFileInput = this.productForm.querySelector("#printFileInput");
      this.summaryInput = this.productForm.querySelector("#summaryInput");
      this.addToCartButton = this.productForm.querySelector(
        "button.product-form__submit"
      );

      this.updateAddToCartButton();

      this.cartVariantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.variantChange,
        (event) => this.onCartVariantChange(event)
      );
    });
  }

  disconnectedCallback() {
    if (this.cartVariantChangeUnsubscriber) {
      this.cartVariantChangeUnsubscriber();
    }
  }

  /**
   * Waits for the product form to exist in the DOM.
   */
  waitForForm() {
    return new Promise((resolve) => {
      const checkForm = () => {
        this.productForm = document.getElementById(this.#formId);
        this.productForm ? resolve() : requestAnimationFrame(checkForm);
      };
      checkForm();
    });
  }

  updateAddToCartButton() {
    this.addToCartButton.disabled = this.selectedPort === null;
  }

  onCartVariantChange({ data: { variant } }) {
    this.initSelectedMeta();
    this.resetSelectedMeta();
    if (this.selectedPort) {
      const pathSlug = PORT_STICKER_VARIANTS[variant.id].pathSlug;
      const designImageUrl = `${SB_IMG_BASE}/cruise-badges/ports/design/${pathSlug}/${this.selectedPort.slug}.png`;
      const displayImageUrl = `${SB_IMG_BASE}/cruise-badges/ports/${pathSlug}/${this.selectedPort.slug}.jpg`;
      this.printFileInput.value = designImageUrl;
      this.summaryInput.value = `${this.selectedPort.name} ${pathSlug} Sticker`;
      this.mediaSlideImages[0].src = displayImageUrl;
      this.mediaSlideImages[0].removeAttribute("srcset");
      this.mediaSlideImages[0].removeAttribute("sizes");
      this.modalImages[0].src = displayImageUrl;
      this.modalImages[0].removeAttribute("srcset");
      this.modalImages[0].removeAttribute("sizes");
    }

    this.updateAddToCartButton();
  }
}

customElements.define("variant-picker-port", VariantPickerPort);
